import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SMNavbar from './components/SMNavbar';
import HomePage from './pages/HomePage';
import ListPage from './pages/ListPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import ServiceEditorPage from './pages/ServiceEditorPage';
import { User } from '../../../models/auth';
import './css/serviceManagement.css';

interface ServiceManagementAppProps {
  user: User;
  userToken?: string;
  onLogout: () => void;
}

const ServiceManagementApp: React.FC<ServiceManagementAppProps> = ({ user, userToken, onLogout }) => {
  return (
    <div className="gpt-ceu-control-app-wrapper">
      <SMNavbar userName={user.name} userEmail={user.email} userToken={userToken} onLogout={onLogout} />
      
      <main className="main-content sm-main-content">
        <Routes>
          <Route path="/" element={<HomePage user={user} />} />
          <Route path="/lista" element={<ListPage />} />
          <Route path="/servicio/:name" element={<ServiceDetailPage user={user} />} />
          <Route path="/servicio/:name/editor" element={<ServiceEditorPage user={user} />} />
          <Route path="*" element={<Navigate to="/gestion-servicios" replace />} />
        </Routes>
      </main>
    </div>
  );
};

export default ServiceManagementApp;
